<script setup lang="ts">
import { useArticleFeedbackModalStore } from "@/stores";

import LeArticleFeedbackModal from "./articles/LeArticleFeedbackModal.vue";

const articleFeedbackModalStore = useArticleFeedbackModalStore();
</script>

<template>
  <LeArticleFeedbackModal
    v-if="
      articleFeedbackModalStore.article && articleFeedbackModalStore.dictionary && articleFeedbackModalStore.methodId
    "
    :is-open="articleFeedbackModalStore.isFeedbackModalOpen"
    :article="articleFeedbackModalStore.article"
    :dictionary="articleFeedbackModalStore.dictionary"
    :method-id="articleFeedbackModalStore.methodId"
    @close="articleFeedbackModalStore.closeFeedbackModal($event)"
  />
</template>
